/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts https://shopify.dev/api/admin/rest/reference/shipping-and-fulfillment/fulfillmentorder
 * API Version: 2022-01
 */

import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyDeliveryMethodKey,
  ShopifyDeliveryMethodToFulfillmentOrderKey,
  ShopifyFulfillmentHoldKey,
  ShopifyFulfillmentHoldToFulfillmentOrderKey,
  ShopifyFulfillmentOrderDestinationKey,
  ShopifyFulfillmentOrderDestinationToFulfillmentOrderKey,
  ShopifyFulfillmentOrderKey,
  ShopifyFulfillmentOrderLineItemKey,
  ShopifyFulfillmentOrderLineItemToFulfillmentOrderKey,
  ShopifyFulfillmentOrderMerchantRequestKey,
  ShopifyFulfillmentOrderMerchantRequestToFulfillmentOrderKey,
  ShopifyFulfillmentOrderToFulfillmentOrderLineItemsKey,
  ShopifyFulfillmentOrderToFulfillmentOrderMerchantRequestKey,
  ShopifyFulfillmentOrderToLocationKey,
  ShopifyFulfillmentOrderToOrderKey,
  ShopifyFulfillmentOrderToShopKey,
  ShopifyLocationKey,
  ShopifyOrderKey,
  ShopifyShopKey,
} from "./keys";
import type { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyFulfillmentOrderKey,
  "2022-01": {
    name: "Shopify Fulfillment Order",
    fields: [
      {
        // TODO: Convert to BelongsTo of FulfillmentOrderAssignedLocation
        name: "Assigned Location",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "assigned_location" } },
      },
      {
        // TODO: Convert to BelongsTo of DeliveryMethod
        name: "Delivery Method",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "delivery_method" } },
      },
      {
        // TODO: Convert to BelongsTo of FulfillmentOrderDestination
        name: "Destination",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "destination" } },
      },
      {
        name: "Fulfill At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "fulfill_at" } },
      },
      {
        name: "Fulfillment Holds",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "fulfillment_holds" } },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id" } },
      },
      {
        name: "International Duties",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "international_duties" } },
      },
      {
        name: "Fulfillment Order Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyFulfillmentOrderToFulfillmentOrderLineItemsKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "line_items" } },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyFulfillmentOrderLineItemKey,
          inverseFieldKey: ShopifyFulfillmentOrderLineItemToFulfillmentOrderKey,
        },
      },
      {
        name: "Merchant Requests",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "merchant_requests" } },
      },
      {
        name: "Order",
        fieldType: FieldType.BelongsTo,
        key: ShopifyFulfillmentOrderToOrderKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "order_id" } },
        configuration: {
          relatedModelKey: ShopifyOrderKey,
        },
      },
      {
        name: "Request Status",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "request_status" } },
      },
      {
        name: "Status",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "status" } },
      },
      {
        name: "Supported Actions",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "supported_actions" } },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyFulfillmentOrderToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: { type: "rest_sublist", resource: "fulfillmentOrder", parent: "order" },
  },
  "2022-04": {
    fields: [
      {
        name: "Fulfill By",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "fulfill_by" } },
      },
    ],
  },
  "2023-07": {
    fields: [
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "created_at",
          },
        },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "updated_at",
          },
        },
      },
      {
        name: "Location",
        fieldType: FieldType.BelongsTo,
        key: ShopifyFulfillmentOrderToLocationKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "assigned_location_id",
          },
        },
        configuration: {
          relatedModelKey: ShopifyLocationKey,
        },
      },
    ],
  },
  "2025-04": {
    graphQLTypename: "FulfillmentOrder",
    fields: [
      {
        name: "Assigned Location",
        fieldType: FieldType.JSON,
        shouldConvergeField: (_, requestedScopes) => {
          return requestedScopes.includes("read_locations") || requestedScopes.includes("write_locations");
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "assigned_location",
            graphQLFieldKey: "assignedLocation",
            graphQLSelection: `
          address1
          address2
          city
          countryCode
          location {
            id
          }
          name
          phone
          province
          zip
          `,
          },
        },
      },
      {
        name: "Delivery Method",
        fieldType: FieldType.HasOne,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "delivery_method",
            graphQLFieldKey: "deliveryMethod",
            graphQLSelection: `
          id
          additionalInformation {
            instructions
            phone
          }
          brandedPromise {
            handle
            name
          }
          maxDeliveryDateTime
          methodType
          minDeliveryDateTime
          presentedName
          serviceCode
          sourceReference
          `,
            protectedCustomerData: ["phone"],
          },
        },
        configuration: {
          relatedModelKey: ShopifyDeliveryMethodKey,
          inverseFieldKey: ShopifyDeliveryMethodToFulfillmentOrderKey,
        },
      },
      {
        name: "Destination",
        fieldType: FieldType.HasOne,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "destination",
            graphQLFieldKey: "destination",
            graphQLSelection: `
          id
          address1
          address2
          city
          countryCode
          location { id }
          email
          company
          firstName
          lastName
          phone
          province
          zip
          `,
            protectedCustomerData: ["address", "name", "phone"],
          },
        },
        configuration: {
          relatedModelKey: ShopifyFulfillmentOrderDestinationKey,
          inverseFieldKey: ShopifyFulfillmentOrderDestinationToFulfillmentOrderKey,
        },
      },
      {
        name: "Fulfill At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "fulfill_at", graphQLFieldKey: "fulfillAt" } },
      },
      {
        name: "Fulfillment Holds",
        fieldType: FieldType.HasMany,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "fulfillment_holds",
            graphQLFieldKey: "fulfillmentHolds",
            graphQLSelection: `
              id
              displayReason
              handle
              reason
              reasonNotes
            `,
            selectForHasMany: true,
          },
        },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyFulfillmentHoldKey,
          inverseFieldKey: ShopifyFulfillmentHoldToFulfillmentOrderKey,
        },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id", graphQLFieldKey: "id" } },
      },
      {
        name: "International Duties",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "international_duties",
            graphQLFieldKey: "internationalDuties",
            graphQLSelection: `incoterm`,
          },
        },
      },
      {
        name: "Fulfillment Order Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyFulfillmentOrderToFulfillmentOrderLineItemsKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "line_items" } },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyFulfillmentOrderLineItemKey,
          inverseFieldKey: ShopifyFulfillmentOrderLineItemToFulfillmentOrderKey,
        },
      },
      {
        name: "Merchant Requests",
        fieldType: FieldType.HasMany,
        key: ShopifyFulfillmentOrderToFulfillmentOrderMerchantRequestKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "merchant_requests" } },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyFulfillmentOrderMerchantRequestKey,
          inverseFieldKey: ShopifyFulfillmentOrderMerchantRequestToFulfillmentOrderKey,
        },
      },
      {
        name: "Order",
        fieldType: FieldType.BelongsTo,
        key: ShopifyFulfillmentOrderToOrderKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "order_id", graphQLFieldKey: "order", graphQLSelection: "id" },
        },
        configuration: {
          relatedModelKey: ShopifyOrderKey,
        },
      },
      {
        name: "Request Status",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "request_status",
            graphQLFieldKey: "requestStatus",
            isShopifyEnum: true,
            availableInWebhook: {
              "fulfillment_orders/cancellation_request_rejected": "fulfillment_order.request_status",
              "fulfillment_orders/cancellation_request_submitted": "fulfillment_order.request_status",
              "fulfillment_orders/fulfillment_request_accepted": "fulfillment_order.request_status",
              "fulfillment_orders/fulfillment_request_rejected": "fulfillment_order.request_status",
              "fulfillment_orders/fulfillment_request_submitted": "submitted_fulfillment_order.request_status",
            },
          },
        },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: [
            { name: "UNSUBMITTED" },
            { name: "SUBMITTED" },
            { name: "ACCEPTED" },
            { name: "REJECTED" },
            { name: "CANCELLATION_REQUESTED" },
            { name: "CANCELLATION_ACCEPTED" },
            { name: "CANCELLATION_REJECTED" },
            { name: "CLOSED" },
          ],
        },
      },
      {
        name: "Status",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "status",
            graphQLFieldKey: "status",
            isShopifyEnum: true,
            availableInWebhook: {
              "fulfillment_orders/cancellation_request_accepted": "fulfillment_order.status",
              "fulfillment_orders/cancellation_request_rejected": "fulfillment_order.status",
              "fulfillment_orders/cancellation_request_submitted": "fulfillment_order.status",
              "fulfillment_orders/cancelled": "replacement_fulfillment_order.status",
              "fulfillment_orders/fulfillment_request_accepted": "fulfillment_order.status",
              "fulfillment_orders/fulfillment_request_rejected": "fulfillment_order.status",
              "fulfillment_orders/fulfillment_request_submitted": "submitted_fulfillment_order.status",
              "fulfillment_orders/fulfillment_service_failed_to_complete": "fulfillment_order.status",
              "fulfillment_orders/hold_released": "fulfillment_order.status",
              "fulfillment_orders/line_items_prepared_for_local_delivery": "fulfillment_order.status",
              "fulfillment_orders/line_items_prepared_for_pickup": "fulfillment_order.status",
              "fulfillment_orders/merged": "fulfillment_order_merges.fulfillment_order.status",
              "fulfillment_orders/moved": "moved_fulfillment_order.status",
              "fulfillment_orders/order_routing_complete": "fulfillment_order.status",
              "fulfillment_orders/placed_on_hold": "fulfillment_order.status",
              "fulfillment_orders/rescheduled": "fulfillment_order.status",
              "fulfillment_orders/scheduled_fulfillment_order_ready": "fulfillment_order.status",
              "fulfillment_orders/split": "remaining_fulfillment_order.status",
            },
          },
        },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: [
            { name: "OPEN" },
            { name: "IN_PROGRESS" },
            { name: "CANCELLED" },
            { name: "INCOMPLETE" },
            { name: "CLOSED" },
            { name: "SCHEDULED" },
            { name: "ON_HOLD" },
          ],
        },
      },
      {
        name: "Supported Actions",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "supported_actions",
            graphQLFieldKey: "supportedActions",
            graphQLSelection: `
          action
          externalUrl
          `,
          },
        },
      },
      {
        name: "Fulfill By",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "fulfill_by", graphQLFieldKey: "fulfillBy" } },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "created_at",
            graphQLFieldKey: "createdAt",
          },
        },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "updated_at",
            graphQLFieldKey: "updatedAt",
          },
        },
      },
      {
        name: "Location",
        fieldType: FieldType.BelongsTo,
        key: ShopifyFulfillmentOrderToLocationKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "assigned_location_id",
            graphQLFieldKey: "assignedLocationId",
            skipGraphQLSelection: true,
          },
        },
        configuration: {
          relatedModelKey: ShopifyLocationKey,
        },
      },
      {
        name: "Order Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "order_name", graphQLFieldKey: "orderName" } },
      },
      {
        name: "Order Processed At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "order_processed_at",
            graphQLFieldKey: "orderProcessedAt",
          },
        },
      },
    ],
    syncConfig: {
      type: "graphql_list",
      resource: "fulfillmentOrders",
      filters: { updatedAt: { sortKey: "UPDATED_AT" } },
      sortableBy: { updatedAt: { sortKey: "UPDATED_AT", reverse: true } },
    },
  },
  "2026-04": {
    fields: [
      {
        name: "Remaining Line Items Weight",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "remainingLineItemsWeight",
            graphQLSelection: `
          unit
          value
          `,
          },
        },
      },
    ],
  },
};

export const ShopifyFulfillmentOrder = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
